import styled from "styled-components";

export const NavGroupWrapper = styled.div`
  position: relative;
  width: 100%;
  margin-bottom: 10px;

  .nav-group-children {
    display: none;
    flex-direction: column;
    padding-left: 18px;
    margin-top: 4px;
    position: relative;

    &::before {
      content: "";
      position: absolute;
      left: 8px;
      top: 0;
      bottom: 0;
      width: 1px;
      background: #313131;
    }
  }

  &:hover .nav-group-children,
  &:focus-within .nav-group-children,
  &.force-open .nav-group-children {
    display: flex;
  }
`;
